export default "/images/a7c9956deab74bb04c517db9f92d8551.avif";